import { useEffect, useState } from "react";
import { EMPTY_STRING } from "../constants";

export default function useAutoDismissMessage(durationMs) {
    const [message, setMessage] = useState(EMPTY_STRING);

    useEffect(() => {
        if (!message) return;
        const id = setTimeout(() => setMessage(EMPTY_STRING), durationMs);
        return () => clearTimeout(id);
    }, [message, durationMs]);

    return [message, setMessage];
}
